<nav class="_vbox _sidebar">
  <dt-sidebar-brand-logo></dt-sidebar-brand-logo>
  <!--  <section class="pt-5 px-4">-->
  <!--    <dt-workspace-selector></dt-workspace-selector>-->
  <!--  </section>-->
  <section class="overflow-y-auto flex-grow">
    <ul class="p-2 m-0 overflow-hidden">
      <li>
        <!--        <a-->
        <!--          pStyleClass="@next"-->
        <!--          enterFromClass="hidden"-->
        <!--          enterActiveClass="animate-slidedown"-->
        <!--          leaveToClass="hidden"-->
        <!--          leaveActiveClass="animate-slideup"-->
        <!--        >-->
        <a
          [routerLink]="['design-tokens']"
          routerLinkActive="active-link"
          #tokensPage="routerLinkActive"
        >
          <i class="{{ PrimeIcons.BOX }}"></i>
          <span>Design Tokens</span>
          <i class="{{ PrimeIcons.CHEVRON_DOWN }}"></i>
        </a>
        @if (tokensPage.isActive) {
          <dt-themes-overview></dt-themes-overview>
        }
      </li>
      <li>
        <a
          [routerLink]="['export']"
          routerLinkActive="active-link"
          #exportPage="routerLinkActive"
        >
          <i class="{{ PrimeIcons.UPLOAD }}"></i>
          <span>Export</span>
          <i class="{{ PrimeIcons.CHEVRON_DOWN }}"></i>
        </a>
        <ul>
          @if (exportPage.isActive) {
            @for (exportOption of exportOptions; track exportOption.title) {
              <li>
                @if (exportOption.path) {
                  <a
                    routerLinkActive="active-link"
                    [routerLink]="['export', exportOption.path]"
                  >
                    <span>{{ exportOption.title }}</span>
                  </a>
                } @else if (exportOption.url) {
                  <a
                    [href]="exportOption.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{{ exportOption.title }}</span>
                  </a>
                } @else if (exportOption.onClick) {
                  <a (click)="exportOption.onClick()">
                    <span>{{ exportOption.title }}</span>
                  </a>
                }
              </li>
            }
          }
        </ul>
      </li>
      <li>
        <a
          [routerLink]="['import']"
          routerLinkActive="active-link"
          #importPage="routerLinkActive"
        >
          <i class="{{ PrimeIcons.DOWNLOAD }}"></i>
          <span>Import</span>
          <i class="{{ PrimeIcons.CHEVRON_DOWN }}"></i>
        </a>
        <ul>
          @if (importPage.isActive) {
            @for (importOption of importOptions; track importOption.path) {
              <li>
                @if (importOption.path) {
                  <a
                    routerLinkActive="active-link"
                    [routerLink]="['import', importOption.path]"
                  >
                    <span>{{ importOption.title }}</span>
                  </a>
                } @else if (importOption.url) {
                  <a
                    [href]="importOption.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{{ importOption.title }}</span>
                  </a>
                } @else if (importOption.onClick) {
                  <a (click)="importOption.onClick()">
                    <span>{{ importOption.title }}</span>
                  </a>
                }
              </li>
            }
          }
        </ul>
      </li>
      @if (showTeamLink()) {
        <li>
          <a [routerLink]="['team']" routerLinkActive="active-link">
            <i class="{{ PrimeIcons.USERS }}"></i>
            <span>Team</span>
          </a>
        </li>
      }
    </ul>
  </section>
  <section>
    <dt-sidebar-footer></dt-sidebar-footer>
  </section>
</nav>
